import { assign } from 'lodash';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductAsset from 'src/app/model/product-asset';
import {
  SubProject,
  SUB_PROJECT_TYPES,
} from 'src/app/model/project/sub-project';
import RegisteredAction from 'src/app/model/registered-action';
import { ImmoIPProductChangesObject } from '../../immo-ip-placer-offline-changes/immo-ip-product-changes/immo-ip-product-changes-object';
import { ImmoIPSubProjectChangesObject } from '../../immo-ip-placer-offline-changes/immo-ip-sub-project-changes/immo-ip-sub-project-changes-object';

export class ImmoIPPlacerSubmitHelper {
  private constructor() {}

  static addProductAssets(
    subProject: SubProject,
    param: AddProductAssetsParameterObject
  ): void {
    if (
      param == null ||
      !CollectionHelper.isPopulated(param.productAssets) ||
      subProject == null ||
      subProject.project == null ||
      !CollectionHelper.isPopulated(subProject.project.products)
    ) {
      return;
    }

    const matchingProduct = subProject.project.products.find(
      (p) => p.id === param.productId
    );
    if (matchingProduct.productAssets == null) {
      matchingProduct.productAssets = [];
    }
    matchingProduct.productAssets.push(...param.productAssets);
  }

  static addProjectPlacementAssets(
    subProject: SubProject,
    projectPlacementAssets: ProductAsset[]
  ): void {
    if (
      !CollectionHelper.isPopulated(projectPlacementAssets) ||
      subProject == null ||
      subProject.projectPlacement == null
    ) {
      return;
    }

    if (subProject.projectPlacement.projectPlacementAssets == null) {
      subProject.projectPlacement.projectPlacementAssets = [];
    }
    subProject.projectPlacement.projectPlacementAssets.push(
      ...projectPlacementAssets
    );
  }

  static addRegisteredActions(
    subProject: SubProject,
    registeredActions: RegisteredAction[]
  ): void {
    if (
      !CollectionHelper.isPopulated(registeredActions) ||
      subProject == null
    ) {
      return;
    }

    subProject.projectPlacement.registeredActions = [...registeredActions];
  }

  static updateSubProjectExecution(
    subProject: SubProject,
    param: UpdateSubProjectExecutionParameterObject
  ): void {
    if (
      subProject == null ||
      param == null ||
      param.subProjectChanges == null
    ) {
      return;
    }

    subProject.status = param.subProjectStatus;
    subProject.currentExecutionDate =
      param.subProjectChanges.currentExecutionDate;

    if (
      subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
      subProject.project != null &&
      CollectionHelper.isPopulated(subProject.project.products) &&
      CollectionHelper.isPopulated(param.productChangesArr)
    ) {
      const productChangesMap = new Map<number, ImmoIPProductChangesObject>(
        param.productChangesArr.map((c) => [c.id, c])
      );
      subProject.project.products.forEach((p) => {
        if (p.productPlacement == null) {
          return;
        }
        const productChanges = productChangesMap.get(p.id);
        if (productChanges == null) {
          return;
        }
        p.productPlacement.installerFeedback = productChanges.installerFeedback;
        p.productPlacement.executionComplete = productChanges.executionComplete;
        p.productPlacement.executionDate = productChanges.executionDate;
        p.productPlacement.executionTime = productChanges.executionTime;
      });
    }

    if (
      subProject.type !== SUB_PROJECT_TYPES.BASE_PROJECT &&
      subProject.projectPlacement != null
    ) {
      subProject.projectPlacement.placerFeedback =
        param.subProjectChanges.placerFeedback;
      subProject.projectPlacement.placementDone =
        param.subProjectChanges.placementDone;
    }

    if (
      subProject.projectPlacement != null &&
      CollectionHelper.isPopulated(param.subProjectChanges.registeredActions)
    ) {
      subProject.projectPlacement.registeredActions = [
        ...param.subProjectChanges.registeredActions,
      ];
    }
  }

  static replaceSubProjectFields(
    toReplace: SubProject,
    replaceSource: SubProject
  ): void {
    if (toReplace == null || replaceSource == null) {
      return;
    }

    assign(toReplace, replaceSource);
  }
}

export interface AddProductAssetsParameterObject {
  productId: number;
  productAssets: ProductAsset[];
}

export interface UpdateSubProjectExecutionParameterObject {
  subProjectStatus: string;
  subProjectChanges: ImmoIPSubProjectChangesObject;
  productChangesArr: ImmoIPProductChangesObject[];
}
